import PropTypes from 'prop-types';

import {
  formatTimeLabel,
  getScheduleWindowBlockStyle,
  hasVotingWindows,
} from '../utils/votingScheduleFormatter';

const SLOT_ROW_HEIGHT = 28;

function DayColumn({ day, slots }) {
  const dayWindows = day.windows || [];
  const totalHeight = slots.length * SLOT_ROW_HEIGHT;
  const visibleStartMinutes = slots[0]?.startMinutes || 0;

  return (
    <div className="relative border-r border-stone-200 last:border-r-0">
      <div
        className="relative"
        style={{
          height: `${totalHeight}px`,
          backgroundImage:
            'linear-gradient(to bottom, rgba(120,113,108,0.18) 1px, transparent 1px)',
          backgroundSize: `100% ${SLOT_ROW_HEIGHT}px`,
        }}
      >
        {!hasVotingWindows(dayWindows) ? (
          <div className="pointer-events-none absolute inset-0 flex items-center justify-center px-3">
            <span className="rounded-full border border-dashed border-stone-300 bg-white/80 px-3 py-1 text-xs text-stone-500">
              No voting hours
            </span>
          </div>
        ) : null}

        {dayWindows.map((windowItem) => {
          const style = getScheduleWindowBlockStyle(
            windowItem,
            SLOT_ROW_HEIGHT,
            visibleStartMinutes
          );

          return (
            <div
              key={windowItem.id}
              className="absolute left-1.5 right-1.5 overflow-hidden rounded-2xl border border-stone-900 bg-stone-900 px-3 py-2 text-white shadow-sm"
              style={style}
            >
              <div className="text-xs font-semibold uppercase tracking-[0.12em] text-stone-200">
                {windowItem.label}
              </div>
              <div className="mt-1 text-sm font-semibold">
                {windowItem.displayStartTime}–{windowItem.displayEndTime}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

DayColumn.propTypes = {
  day: PropTypes.shape({
    windows: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  slots: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export function ElectionWeekCalendarGrid({ week, slots }) {
  const totalHeight = slots.length * SLOT_ROW_HEIGHT;

  return (
    <div className="grid grid-cols-[4.75rem_repeat(7,minmax(8rem,1fr))] gap-0">
      <div className="border-r border-stone-200 bg-white">
        <div className="relative" style={{ height: `${totalHeight}px` }}>
          {slots.map((slot, index) => (
            <div
              key={slot.key}
              className="absolute inset-x-0 border-b border-stone-200 px-2 text-[11px] text-stone-500"
              style={{
                top: `${index * SLOT_ROW_HEIGHT}px`,
                height: `${SLOT_ROW_HEIGHT}px`,
              }}
            >
              <span className="relative top-0 inline-block -translate-y-1/2 bg-white pr-1">
                {formatTimeLabel(slot.time)}
              </span>
            </div>
          ))}
        </div>
      </div>

      {week.days.map((day) => (
        <DayColumn key={day.date} day={day} slots={slots} />
      ))}
    </div>
  );
}

ElectionWeekCalendarGrid.propTypes = {
  week: PropTypes.shape({
    days: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  slots: PropTypes.arrayOf(PropTypes.object).isRequired,
};
